'use strict'

angular
  .module('basalteApp')
  .service('Lights', [
    '$rootScope',
    'BAS_ROOMS',
    'BAS_LIGHT',
    'BAS_SHARED_SERVER_STORAGE',
    'CurrentRoom',
    'RoomsHelper',
    Lights
  ])

/**
 * Keeps basRoomLights in sync
 *
 * @constructor
 * @param $rootScope
 * @param {BAS_ROOMS} BAS_ROOMS
 * @param {BAS_LIGHT} BAS_LIGHT
 * @param {BAS_SHARED_SERVER_STORAGE} BAS_SHARED_SERVER_STORAGE
 * @param {CurrentRoom} CurrentRoom
 * @param {RoomsHelper} RoomsHelper
 */
function Lights (
  $rootScope,
  BAS_ROOMS,
  BAS_LIGHT,
  BAS_SHARED_SERVER_STORAGE,
  CurrentRoom,
  RoomsHelper
) {

  /**
   * @type {BasRooms}
   */
  const rooms = BAS_ROOMS.ROOMS

  /**
   * @type {TCurrentRoomState}
   */
  const currentRoom = CurrentRoom.get()

  init()

  function init () {

    $rootScope.$on(
      BAS_SHARED_SERVER_STORAGE.EVT_LIGHT_GROUP_ORDER_UPDATED,
      syncLights
    )

    $rootScope.$on(
      BAS_LIGHT.EVT_LIGHT_DEVICE_TOGGLE_UPDATED,
      _syncGroupToggleState
    )

    $rootScope.$on(
      BAS_LIGHT.EVT_LIGHT_DEVICE_WHITE_UPDATED,
      _syncGroupBrightnessSlider
    )

    $rootScope.$on(
      BAS_LIGHT.EVT_LIGHT_DEVICE_BRIGHTNESS_UPDATED,
      _syncGroupBrightnessSlider
    )
  }

  function syncLights () {

    RoomsHelper.forEachRoom(room => room.lights?.syncLights())
  }

  function _syncGroupToggleState () {
    const basRoomLights = rooms.rooms[currentRoom.roomId]?.lights

    if (basRoomLights?.uiUserLightGroups) {

      for (const uiLightGroup of basRoomLights.uiUserLightGroups) {

        basRoomLights.updateGroupToggleStateWithWhiteSupport(uiLightGroup)
      }
    }
  }

  function _syncGroupBrightnessSlider () {
    rooms.rooms[currentRoom.roomId]?.lights?.syncGroupBrightnessSlider()
  }
}
